import React, { useEffect, useState } from 'react';
import { Typography, Grid, Card, CardContent, Box, Button } from '@mui/material';
import LGD from '../../components/lgd';
import Ministry from '../../components/ministry';
import Event from '../../components/event';
import axios from 'axios';
import TableComponent from '../../components/table';
import { useSelector } from 'react-redux';
import { getEventDetailedReport } from '../../api';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';

const dataRow = {
  event_name: 'Event Name',
  event_count: 'Event Count',
};

const EventDetailedReport = ({ year } = {}) => {
  const [selectedEventThemeCode, setSelectedEventThemeCode] = useState(undefined);
  const [selectedEventNameCode, setSelectedEventNameCode] = useState(undefined);
  const [selectedEventHeadingCode, setSelectedEventHeadingCode] = useState(undefined);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedStateCode, setSelectedStateCode] = useState(undefined);
  const [selectedDistrictCode, setSelectedDistrictCode] = useState(undefined);
  const [selectedBlockCode, setSelectedBlockCode] = useState(undefined);
  const [selectedGPCode, setSelectedGPCode] = useState(undefined);
  const [selectedVillageCode, setSelectedVillageCode] = useState(undefined);
  const [selectedULBCode, setSelectedULBCode] = useState(undefined);
  const [ministryCode, setMinistryCode] = useState(undefined);
  const [ministryDepartmentCode, setMinistryDepartmentCode] = useState(undefined);
  const [ministrySubUnitCode, setMinistrySubUnitCode] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const role = useSelector((state) => state.RoleReducer);

  const { enqueueSnackbar } = useSnackbar();

  //   useEffect(() => {
  //     if (role?.info?.role_id === 1) {
  //       getReports();
  //     }
  //     if (role?.info?.role_id === 2 && ministryCode) {
  //       getReports();
  //     }
  //     if (role?.info?.role_id === 3 && ministryDepartmentCode) {
  //       getReports();
  //     }
  //     if (role?.info?.role_id === 4 && ministrySubUnitCode) {
  //       getReports();
  //     }
  //     if (role?.info?.role_id === 5 && selectedStateCode) {
  //       getReports();
  //     }
  //     if (role?.info?.role_id === 6 && selectedDistrictCode) {
  //       getReports();
  //     }
  //     if (role?.info?.role_id === 7 && selectedULBCode) {
  //       getReports();
  //     }
  //     if (role?.info?.role_id === 8 && selectedBlockCode) {
  //       getReports();
  //     }
  //     if (role?.info?.role_id === 13 && ministryCode) {
  //       getReports();
  //     }
  //   }, [
  //     selectedEventThemeCode,
  //     selectedEventHeadingCode,
  //     selectedEventNameCode,
  //     selectedLocation,
  //     selectedStateCode,
  //     selectedDistrictCode,
  //     selectedBlockCode,
  //     selectedULBCode,
  //     selectedGPCode,
  //     selectedVillageCode,
  //     ministryCode,
  //     ministryDepartmentCode,
  //     ministrySubUnitCode,
  //     role,
  //   ]);

  const handleDownload = async () => {
    setIsLoading(true);

    let payload = {};

    if (selectedLocation) {
      payload = {
        ...payload,
        location_type: selectedLocation,
      };
    }

    if (selectedStateCode) {
      payload = {
        ...payload,
        state_code: selectedStateCode,
      };
    }

    if (selectedDistrictCode) {
      payload = {
        ...payload,
        district_code: selectedDistrictCode,
      };
    }

    if (selectedULBCode) {
      payload = {
        ...payload,
        ulb_code: selectedULBCode,
      };
    }

    if (selectedBlockCode) {
      payload = {
        ...payload,
        block_code: selectedBlockCode,
      };
    }

    if (selectedGPCode) {
      payload = {
        ...payload,
        gp_code: selectedGPCode,
      };
    }

    if (selectedVillageCode) {
      payload = {
        ...payload,
        village_code: selectedVillageCode,
      };
    }

    if (ministryCode) {
      payload = {
        ...payload,
        ministry_code: ministryCode,
      };
    }

    if (ministryDepartmentCode) {
      payload = {
        ...payload,
        ministry_department_code: ministryDepartmentCode,
      };
    }

    if (ministrySubUnitCode) {
      payload = {
        ...payload,
        ministry_unit_code: ministrySubUnitCode,
      };
    }

    if (selectedEventThemeCode) {
      payload = {
        ...payload,
        event_theme_id: selectedEventThemeCode,
      };
    }

    if (selectedEventHeadingCode) {
      payload = {
        ...payload,
        event_heading_id: selectedEventHeadingCode,
      };
    }

    if (selectedEventNameCode) {
      payload = {
        ...payload,
        event_name_id: selectedEventNameCode,
      };
    }

    try {
      const res = await getEventDetailedReport(payload);
      console.log(res);

      if (res.status === 200 && res.data?.fileUrl) {
        // Create a temporary link element
        const link = document.createElement('a');
        link.href = res.data.fileUrl; // Use the signed URL from the response
        link.setAttribute('download', 'event_report'); // Optional: Set a default file name
        document.body.appendChild(link); // Append to the body
        link.click(); // Trigger the download
        document.body.removeChild(link); // Clean up after download
      } else {
        enqueueSnackbar('Download Failed', { variant: 'error' });
      }
    } catch (error) {
      console.error('Download Error:', error);
      enqueueSnackbar('Download Failed', { variant: 'error' });
    } finally {
      setIsLoading(false); // Ensure loading state is disabled in all cases
    }
  };

  return (
    <Grid container spacing={2} mb={2} mt={2}>
      <Event
        selectedEventThemeCode={selectedEventThemeCode}
        setSelectedEventThemeCode={setSelectedEventThemeCode}
        selectedEventNameCode={selectedEventNameCode}
        setSelectedEventNameCode={setSelectedEventNameCode}
        selectedEventHeadingCode={selectedEventHeadingCode}
        setSelectedEventHeadingCode={setSelectedEventHeadingCode}
      />
      {role?.info?.role_id !== 13 && (
        <LGD
          eventYear={year}
          selectedLocation={selectedLocation}
          setSelectedLocation={setSelectedLocation}
          selectedStateCode={selectedStateCode}
          setSelectedStateCode={setSelectedStateCode}
          selectedDistrictCode={selectedDistrictCode}
          setSelectedDistrictCode={setSelectedDistrictCode}
          selectedBlockCode={selectedBlockCode}
          setSelectedBlockCode={setSelectedBlockCode}
          selectedULBCode={selectedULBCode}
          setSelectedULBCode={setSelectedULBCode}
          selectedGPCode={selectedGPCode}
          setSelectedGPCode={setSelectedGPCode}
          selectedVillageCode={selectedVillageCode}
          setSelectedVillageCode={setSelectedVillageCode}
        />
      )}
      <Ministry
        ministryCode={ministryCode}
        setMinistryCode={setMinistryCode}
        ministryDepartmentCode={ministryDepartmentCode}
        setMinistryDepartmentCode={setMinistryDepartmentCode}
        ministrySubUnitCode={ministrySubUnitCode}
        setMinistrySubUnitCode={setMinistrySubUnitCode}
      />
      <Card sx={{ width: '100%' }}>
        <LoadingButton variant="contained" onClick={handleDownload} loading={isLoading}>
          Download Event Detailed Report
        </LoadingButton>
      </Card>
    </Grid>
  );
};

export default EventDetailedReport;
